var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16973 2.91685V1.5191H9.80775C10.2272 1.5191 10.5673 1.179 10.5673 0.75955C10.5673 0.340096 10.2273 0 9.80775 0H6.19229C5.77284 0 5.43274 0.340096 5.43274 0.75955C5.43274 1.179 5.77284 1.5191 6.19229 1.5191H6.83031V2.91685C3.20039 3.48105 0.413391 6.62777 0.413391 10.4133C0.413391 14.5966 3.81678 17.9999 8.00002 17.9999C12.1833 17.9999 15.5866 14.5965 15.5866 10.4133C15.5866 6.62777 12.7996 3.48105 9.16973 2.91685ZM8.00002 16.4809C4.65435 16.4809 1.93249 13.759 1.93249 10.4134C1.93249 7.06777 4.65442 4.34584 8.00002 4.34584C11.3456 4.34584 14.0676 7.06777 14.0676 10.4134C14.0676 13.759 11.3457 16.4809 8.00002 16.4809Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75958 10.0978V6.51944C8.75958 6.09998 8.41948 5.75989 8.00003 5.75989C7.58057 5.75989 7.24048 6.09998 7.24048 6.51944V10.5359C7.24048 10.6595 7.2897 10.7779 7.3772 10.865L9.50205 12.981C9.79937 13.277 10.2802 13.2759 10.5762 12.9787C10.8722 12.6815 10.8712 12.2005 10.574 11.9045L8.75958 10.0978Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.3fa0a006.svg";
export { ForwardRef as ReactComponent };